import type { ReactNode } from 'react';
import { HelpButton } from '@/help/HelpButton';
import type { HelpTopicId } from '@/help/topics';

export function PageHeader({
  title,
  description,
  actions,
  help,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
  /** Shows a Help button that explains this view (src/help/topics.ts). */
  help?: HelpTopicId;
}) {
  return (
    <div className="flex items-start justify-between gap-4 border-b px-6 py-4">
      <div>
        <h1 className="text-base font-semibold">{title}</h1>
        {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
      </div>
      {(actions || help) && (
        <div className="flex items-center gap-2">
          {help && <HelpButton topic={help} />}
          {actions}
        </div>
      )}
    </div>
  );
}
